import React, { useCallback, useEffect, useRef, useState } from 'react'
import BasicTable from '../../../../Components/CommonTable/BasicTable/BasicTable'
import { canlenderFilter, Columns, data, filters, searchBy  } from '../../../../service/DeliveryFeeService.js';
import AddDeliveryFee from './AddDeliveryFee.jsx';
import { DeliveryApi } from '../../../../App/api/DeliveryFee.apis.js';
import { useFetchAll } from '../../../../custom/FetchApiHook.jsx';
import { toast } from 'react-toastify';


function DeliveryFeeCom(disabledFilters,pagination,handlePagination) {
  const [search,setSearch]=useState("");
  const [addDeliveryModal,setAddDeliveryModal]=useState(false);
  const [selectedDeliveryFee, setSelectedDeliveryFee] = useState(null);
  const { value, fetchAllData } = useFetchAll(() => DeliveryApi.getAllDeliveryFee(pagination,search)); 
  const [editDeliveryFee, setEditDeliveryFee] = useState(null);
  const debounceTimeout = useRef(null); 
  // console.log("all data for table",value?.data);
  const deliverFeeData= value?.data?.deliveryFee;
  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  const handleClose=()=>{
    setAddDeliveryModal(false);
  }
  const closeSubCategoryModal=()=>{
    setSelectedDeliveryFee(false);
    setEditDeliveryFee(null);    
  }
 

  
  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked",e);
     //  const row={
     //   filters: null,
     //   first: 0,
     //   multiSortMeta: [],
     //   page: 0,
     //   rows: 10,
     //   sortField: null,
     //   sortOrder: null,
     //   totalPages: 2   
     // }
     const data={
      limit:e.rows,
      page:+e.page+1
     }
     handlePagination && handlePagination(data)
     // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
    }
  
  };
  const handleCellClick = (cell,field="") => {
    // console.log("click on profile:",field);
    // console.log("cell", cell);
  }
  const handleRowClick=(row)=>{
    setAddDeliveryModal(true);
    setSelectedDeliveryFee(row)
    // console.log("row",row)
    // setEditDeliveryFee(row);
    // console.log("row:",row);
    

  }

  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
}, []);

const debouncedSearch = useCallback((s) => {
  if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
  } 
  debounceTimeout.current = setTimeout(() => {
      handleSearch(s); 
  }, 1500);
}, [handleSearch]);

const DataFilter=filters.filter((f)=>disabledFilters?!disabledFilters.includes(f.inputName):true)

const handleClearFilter=()=>{
const clearPagination=  {
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  }
  // console.log('clearPagination',clearPagination);
  handlePagination && handlePagination({clearPagination})
}
const handleFilter=(name,value)=>{
console.table('name,value',name,value);
let data={}
if (name==='search_by') {
  data.sortOrder=value.code
}
else{
 
  const filter={}
  filter[name]=value.code?value.code:value
  data.filter=filter
  
}

// console.log('data',data);
 handlePagination && handlePagination(data)


}
  return (
    <>
      <BasicTable
      columns={Columns}
      data={ deliverFeeData|| []}
      onPaginatorClick={onPaginatorClick}
      paginatorData={{
        filters: null,
        first: 0,
        multiSortMeta: [],
        page: 1,
        rows: 5,
        sortField: null,
        sortOrder: null,
        totalPages: 1  ,
        totalCount: 1  
      }}
      onCellClick={()=>setAddDeliveryModal(true)}
      SearchBy={searchBy}
      handleSearch={debouncedSearch}
      handleFilter={(name,value)=>handleFilter(name,value)}
      handleClearFilter={handleClearFilter}
      filters={DataFilter}
      WeekRange={false}
      MonthRange={true}
      canlenderFilter={canlenderFilter}
      selectedData={selectedDeliveryFee}
      handleCellClick={handleCellClick}
      handleRowClick={ handleRowClick}
      button_name="Add Delivery"
      handleButton={() => {
        // console.log("clicked add delivery");
        setAddDeliveryModal(true);     
        setSelectedDeliveryFee(null)    
      }}
      />
      { addDeliveryModal && <AddDeliveryFee 
  currentItems={selectedDeliveryFee} 
  open={addDeliveryModal} 
  handleClose={handleClose} 
/>}
    </>
  )
}

export default DeliveryFeeCom
